export const css = {
	root: '_3bFvqFRk',
	' _key': 'certwise-theme/dojo/accordion'
};

export default css;
